


<h3 class="mt0">Updox Integration</h3>
<hr class="hr-line mt-lg">

<!-- Local loader — only shown while fetching updox user -->
<div *ngIf="isLoading" class="text-muted p">
  <i class="fa fa-spinner fa-spin vl-m mr-sm"></i> Loading Updox user...
</div>

<!-- User already exists — display view -->
<ng-container *ngIf="!isLoading && updoxUser?.is_persisted && !showForm">
  <div class="row">
    <div class="col-sm-12">
      <ul class="list-unstyled border-list updox-list-settings m0">
        <li class="list" style="border-bottom: none;">

          <div class="row">
            <div class="col-sm-2">
              <label class="field-label">User ID</label>
              <p class="m0">{{ updoxUser.updox_user_id }}</p>
            </div>
            <div class="col-sm-3">
              <label class="field-label">Name</label>
              <p class="m0">{{ updoxUser.first_name }} {{ updoxUser.last_name }}</p>
            </div>
            <div class="col-sm-2">
              <label class="field-label">Username</label>
              <p class="m0">{{ updoxUser.updox_username }}</p>
            </div>
            <div class="col-sm-2">
              <label class="field-label">Status</label>
              <p class="m0">
                <span class="label" [class.label-success]="updoxUser.active" [class.label-danger]="!updoxUser.active">
                  {{ updoxUser.active ? 'Active' : 'Inactive' }}
                </span>
              </p>
            </div>
            <div class="col-sm-3">
              <label class="field-label">Direct Address</label>
              <p class="m0">{{ updoxUser.direct_address }}</p>
            </div>
          </div>
          <div class="row mt">
<!--            <div class="col-sm-3">-->
<!--              <label class="field-label">Status</label>-->
<!--              <p class="m0">-->
<!--                <span class="label" [class.label-success]="updoxUser.active" [class.label-danger]="!updoxUser.active">-->
<!--                  {{ updoxUser.active ? 'Active' : 'Inactive' }}-->
<!--                </span>-->
<!--              </p>-->
<!--            </div>-->
            <div class="col-sm-12 text-right" *ngIf="canManage">
              <a class="btn btn-default btn-outline" (click)="openEditForm()">
                <i class="fa fa-edit vl-m mr-sm"></i>Edit
              </a>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</ng-container>

<!-- No user exists + enterprise user sees Create button -->
<ng-container *ngIf="!isLoading && !updoxUser && !showForm && canManage">
  <div class="media">
    <div class="media-body text-muted media-middle">
      No Updox user has been provisioned for this practice.
    </div>
    <div class="media-right pl-xl">
      <button type="button" class="btn btn-secondary" (click)="openCreateForm()">
        <i class="fa fa-plus mr-sm"></i>Create Updox User
      </button>
    </div>
  </div>
</ng-container>

<!-- Practice user (non-enterprise) with no user -->
<ng-container *ngIf="!isLoading && !updoxUser && !showForm && !canManage">
  <p class="text-muted">No Updox user configured for this practice.</p>
</ng-container>

<!-- Create / Edit form -->
<form #updoxForm="ngForm" (ngSubmit)="save()" *ngIf="showForm && updoxUser">
  <div class="row">
    <div class="col-sm-4 form-group">
      <label class="field-label">Updox User ID <span class="text-danger">*</span></label>
      <input
        class="form-control"
        type="text"
        name="updox_user_id"
        [(ngModel)]="updoxUser.updox_user_id"
        disabled />
      <span class="help-block text-muted fs12">Auto-generated, unique per practice.</span>
    </div>
    <div class="col-sm-4 form-group">
      <label class="field-label">First Name <span class="text-danger">*</span></label>
      <input
        class="form-control"
        type="text"
        name="first_name"
        [(ngModel)]="updoxUser.first_name"
        required />
    </div>
    <div class="col-sm-4 form-group">
      <label class="field-label">Last Name <span class="text-danger">*</span></label>
      <input
        class="form-control"
        type="text"
        name="last_name"
        [(ngModel)]="updoxUser.last_name"
        required />
    </div>
  </div>

  <div class="row">
    <div class="col-sm-4 form-group">
      <label class="field-label">Updox Username <span class="text-danger">*</span></label>
      <input
        class="form-control"
        type="text"
        name="updox_username"
        [(ngModel)]="updoxUser.updox_username"
        required />
    </div>
    <div class="col-sm-4 form-group">
      <label class="field-label">Password <span class="text-danger">*</span></label>
      <input
        class="form-control"
        type="password"
        name="updox_password"
        [(ngModel)]="updoxUser.updox_password"
        [required]="!isEditing" />
      <span *ngIf="isEditing" class="help-block text-muted fs12">Leave blank to keep existing password.</span>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-5 form-group">
      <label class="field-label">Direct Address Local <span class="text-danger">*</span></label>
      <div class="input-group">
        <input
          class="form-control"
          type="text"
          name="direct_address_local"
          [(ngModel)]="updoxUser.direct_address_local"
          (input)="onDirectAddressLocalChange()"
          required />
        <span class="input-group-addon">@{{ directAddressDomain }}</span>
      </div>
    </div>
    <div class="col-sm-4 form-group">
      <label class="field-label">Full Direct Address</label>
      <input
        class="form-control"
        type="text"
        name="direct_address"
        [ngModel]="updoxUser.direct_address"
        disabled />
    </div>
    <div class="col-sm-3 form-group">
      <label class="field-label">Active</label>
      <div class="mt-sm">
        <label class="fw-400">
          <input
            type="checkbox"
            class="mr vl-m"
            name="active"
            [(ngModel)]="updoxUser.active" />
          Active
        </label>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <button
        type="submit"
        class="btn btn-primary mr"
        [disabled]="!updoxForm.form.valid || isSaving">
        <i *ngIf="isSaving" class="fa fa-spinner fa-spin vl-m mr-sm"></i>
        {{ isSaving ? 'Saving...' : (isEditing ? 'Update User' : 'Create User') }}
      </button>
      <button type="button" class="btn btn-default btn-outline" (click)="cancelForm()">
        Cancel
      </button>
    </div>
  </div>
</form>

<hr class="hr-line mt-lg">
